<template>
<!-- 商家联盟 -->
<section class="viewContainer">
  <el-tabs class="el-tabs" v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="我的联盟" name="first"/>
    <el-tab-pane label="入盟邀请" name="second"/>
    <el-tab-pane label="我的员工" name="third"/>
    <el-tab-pane label="店铺(员工)码" name="fourth"/>
    <el-tab-pane label="联盟活动" name="fifth" v-if="youLmId == 1"/>
    <el-tab-pane label="数据统计" name="sixth"/>
  </el-tabs>

  <!-- 我的联盟 -->
  <div v-show="activeName=='first'" class="main_container">
    <!-- 我的联盟主列表 -->
    <div v-if="statusMA==1">
      <!-- 顶部搜索框 -->
      <el-form :inline="true" :model="filters" class="findform">
        <el-form-item style="display:flex;width:30%">
          <el-input v-model="filters.EnterpriseName" placeholder="搜索联盟名称" maxlength="20" style="width:90%"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="createAllianceAddFun" v-if="isCreateMA==0">申请创建联盟</el-button>
        </el-form-item>
      </el-form>
      <div class="reminder">温馨提示：1. 您的用户会只能看到当前主推联盟商家信息； 2.只能设置一个主推联盟</div>
      <div class="table_container">
        <el-table :data="tableListOne" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="联盟名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="联盟联系人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.contactsPhone}}</template>
          </el-table-column>
          <el-table-column label="身份" align="center">
            <template scope="scope">{{scope.row.identityName}}</template>
          </el-table-column>
          <el-table-column label="时间" align="center">
            <template scope="scope">{{scope.row.time}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.stateName}}</template>
          </el-table-column>
          
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
              <span @click="operationButton(scope.row,1)" class="handle" v-if="scope.row.identity==1&&scope.row.state==1"> 取消申请 </span>
              <span class="red" v-if="scope.row.isMainMA==1"> 当前主推 </span>
              <span @click="operationButton(scope.row,2)" class="handle" v-if="scope.row.isMainMA==0&&scope.row.state==2"> 设为主推 </span>
              <span @click="operationButton(scope.row,3)" class="handle" v-if="scope.row.identity==0&&scope.row.state==2"> 退出 </span>
              <span @click="operationButton(scope.row,4)" class="handle" v-if="scope.row.identity==0&&scope.row.state==2"> 查看 </span>
              <span @click="operationButton(scope.row,5)" class="handle" v-if="scope.row.identity==1&&scope.row.state==2"> 管理联盟 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTablm"
        :current-page="lmpageIndex" :page-size="10" :total="lmtotalRowsCount" style="margin:10px 0;float:right"/>
      </div>
      <div class="reminder" style="font-weight: bold;margin-top: 15px;" v-if="tableListOne.length<1">您当前还没加入或创建任何联盟，<span class="btn_operation" @click="createAllianceAddFun">申请创建联盟</span> 或 去看看 <span class="btn_operation" @click="goInvite">入盟邀请</span> 吧!</div>
    </div>
    <!-- 我的联盟--查看联盟 -->
    <div v-if="statusMA==2" style="padding-bottom:100px;">
      <p class="reminder">
        <img :src="basicInformation.logoUrl" class="faceUrl"/>
        联盟名称:{{basicInformation.name}}　　联盟联系人:{{basicInformation.contacts}}　　联系电话:{{basicInformation.contactsPhone}}
      </p>
      <el-form :inline="true" :model="filters" class="findform">
        <!-- 顶部搜索框 -->
        <el-form-item style="display:flex;width:50%">
          <el-input v-model="filters.EnterpriseName" placeholder="搜索店铺名称" maxlength="20" style="width:80%"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="table_container">
        <el-table :data="threeMAList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="店铺名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="负责人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="店铺类型" align="center">
            <template scope="scope">{{scope.row.bbTypeName}}</template>
          </el-table-column>
          <el-table-column label="加入时间" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabThree"
        :current-page="pageIndexThree" :page-size="10" :total="totalRowsCountThree" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <!-- 我的联盟--管理联盟--列表 -->
    <div v-if="statusMA==3">
      <!-- 顶部搜索框 -->
      <el-form :inline="true" :model="filters" class="findform">
        <el-form-item style="display:flex;width:50%">
          <el-input v-model="filters.EnterpriseName" placeholder="搜索店铺名称" maxlength="20" style="width:80%"/>
        </el-form-item>
        <el-form-item style="width:100%">
          <el-button type="danger" @click="onSubmit">查询</el-button>
          <el-button type="danger" @click="dissolutionMA">解散联盟</el-button>
          <el-button type="danger" @click="editMA">编辑联盟信息</el-button>
          <el-button type="danger" @click="inviteMerchants">邀请商家</el-button>
        </el-form-item>
      </el-form>
      <div class="table_container">
        <el-table :data="fourMAList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="店铺名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="负责人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="店铺类型" align="center">
            <template scope="scope">{{scope.row.bbTypeName}}</template>
          </el-table-column>
          <el-table-column label="邀请时间" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.stateName}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template scope="scope">
              <span @click="fourMATipsFun(scope.row,1)" class="handle" v-if="scope.row.state==2"> 取消邀请 </span>
              <span @click="fourMATipsFun(scope.row,2)" class="handle" v-if="scope.row.state==2"> 通知商家 </span>
              <span @click="fourMATipsFun(scope.row,3)" class="handle" v-if="scope.row.state==1"> 移除商家 </span>
              <span @click="sheweiMz(scope.row,3)" class="handle" v-if="scope.row.state==1"> 设为盟主 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabFour"
        :current-page="pageIndexFour" :page-size="10" :total="totalRowsCountFour" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <!-- 我的联盟--管理联盟--邀请商家 -->
    <div class="displayFlex" v-if="statusMA==4">
      <el-card class="box-card card1" :style="'height:'+scrollbarHeight">
        <el-tree :data="oneData" ref="rightsTree" :props="defaultProps" 
        node-key="id" highlight-current @node-click="handleNodeClick" 
        :default-checked-keys="defaultCheckedKeys" class="lineheighttree"/>
      </el-card>

      <el-card class="box-card card2" :style="'height:'+scrollbarHeight">
        <el-form :inline="true" :model="filters" class="findform">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:60%" :label="searchName" label-width="120px">
            <el-input v-model="filters.EnterpriseName" :placeholder="'请输入'+searchName" maxlength="20"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="brandList" :row-key="getRowKey" @selection-change="handleSelectionChange" stripe border>
          <el-table-column type="selection" :reserve-selection="true" align="center" width="55"></el-table-column>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="店铺名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="负责人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabFive"
        :current-page="pageIndexFive" :page-size="10" :total="totalRowsCountFive" style="margin:10px 0;width: 100%;text-align: right;"/>
      </el-card>
    </div>
    <div class="button_wrap2" v-if="statusMA==4">
      <el-button size="small" @click="returnSeeFuna">取消</el-button>
      <el-button size="small" type="danger" @click="saveFun">确定邀请</el-button>
    </div>
    
    <div v-if="statusMA==2" style="margin:15px 0;text-align: center;">
      <el-button @click="returnSeeFun">返回</el-button>
    </div>
    <div v-if="statusMA==3" style="margin:15px 0;text-align: center;">
      <el-button @click="returnFun">返回</el-button>
    </div>
  </div>
  <!-- 入盟邀请 -->
  <div v-show="activeName=='second'" class="main_container">
    <div v-if="statusMA==1">
      <section class="model_section">
        <p class="model_top_title">入盟邀请</p>
      </section>
      <div class="table_container">
        <el-table :data="twoList.resultObj" @selection-change="handleSelectionChange" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="联盟名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="联盟联系人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.contactsPhone}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.stateName}}</template>
          </el-table-column>
          <el-table-column label="邀请时间" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
              <span @click="invitationFun(scope.row,1)" class="handle" v-if="scope.row.state==1"> <i class="el-icon-circle-check"/> 同意 </span>
              <span @click="invitationFun(scope.row,2)" class="handle" v-if="scope.row.state==1"> <i class="el-icon-circle-close"/> 拒绝 </span>
              <span @click="operationButton(scope.row,4)" class="handle"> <i class="el-icon-view"/> 查看 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndexTwo" :page-size="10" :total="totalRowsCountTwo" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <div v-if="statusMA==2" style="padding-bottom:100px;">
      <p class="reminder">
        <img :src="basicInformation.logoUrl" class="faceUrl"/>
        联盟名称:{{basicInformation.name}}　　联盟联系人:{{basicInformation.contacts}}　　联系电话:{{basicInformation.contactsPhone}}
      </p>
      <el-form :inline="true" :model="filters" class="findform">
        <!-- 顶部搜索框 -->
        <el-form-item style="display:flex;width:50%">
          <el-input v-model="filters.EnterpriseName" placeholder="搜索店铺名称" maxlength="20"
            style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="table_container">
        <el-table :data="threeMAList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="店铺名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="负责人" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="店铺类型" align="center">
            <template scope="scope">{{scope.row.bbTypeName}}</template>
          </el-table-column>
          <el-table-column label="加入时间" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabThree"
        :current-page="pageIndexThree" :page-size="10" :total="totalRowsCountThree" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <div v-if="statusMA==2" style="margin-bottom:15px;text-align: center;">
      <el-button @click="returnSeeFun">返回</el-button>
    </div>
  </div>
  <!-- 我的员工 -->
  <div v-show="activeName=='third'" class="main_container">
    <!-- 顶部搜索框 -->
    <el-form :inline="true" :model="filters" class="findform">
      <el-form-item style="display:flex;width:30%">
        <el-input v-model="filters.EnterpriseName" :placeholder="'请输入'+searchName" maxlength="20" style="width:90%"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="addEmployee=true">添加员工</el-button> </el-form-item>
    </el-form>
    <div class="table_container">
      <el-table :data="threeList" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="昵称" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="加入时间" align="center">
          <template scope="scope">{{scope.row.userBindingTime}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="deleteFun(scope.row)" class="handle"> <i class="el-icon-delete"/> 删除员工 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleTabOne"
      :current-page="pageIndexTabOne" :page-size="10" :total="ygtotalRowsCount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 店铺(员工)码 -->
  <div v-show="activeName=='fourth'" class="main_container">
    <div class="QRCodeClass">
      <div style="width: 320px;text-align: center;margin-bottom: 20px;">
        <b style="line-height: 50px;font-size: 16px;display: block;">店铺码</b>
        <img :src="showImageUrl" style="width: 260px;height: auto;margin-bottom: 10px;"/> <br>
        <el-button type="primary" size="small" @click="xiazai()">下载店铺码</el-button>
      </div>
      <div style="width: 320px;text-align: center;margin-bottom: 20px;">
        <b style="line-height: 50px;font-size: 16px;display: block;">员工码</b>
        <img :src="staffQRCode" style="width: 260px;height: auto;margin-bottom: 10px;"/> <br>
        <el-button type="primary" size="small" @click="xiazaiYg()">下载员工码</el-button>
        <br>
      </div>
    </div>
  </div>
  <!-- 联盟活动 -->
  <div v-show="activeName=='fifth'" class="main_container">
    <ActivityManagementList ref="refLmhd" :oneId='oneId' :oneName='oneName' :bbid="bbid"></ActivityManagementList>
  </div>
  <!-- 数据统计 -->
  <div v-show="activeName=='sixth'" class="main_container">
    <div v-if="statusMA==5">
      <el-form class="findform">
        <el-form-item label="" style="display:flex;margin-right: 15px;">
          <el-select v-model="maIdSix" filterable placeholder="请选择联盟">
            <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="display:flex;">
          <el-date-picker type="daterange" v-model="value2" align="right" unlink-panels @change="changeActiveTime"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-radio-group v-model="tabPosition" @change="radioType()" style="margin-left: 15px;">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">近期3天</el-radio-button>
          <el-radio-button label="2">近期7天</el-radio-button>
          <el-radio-button label="3">近期1个月</el-radio-button>
        </el-radio-group>
        <el-form-item style="margin-left: 15px;">
          <el-button type="danger" @click="onSubmitSixFun">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="table_container">
        <el-table :data="allianceDataList" @selection-change="handleSelectionChange" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="店铺名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="员工数（含店铺码）" align="center">
            <template scope="scope">
              <span @click="employeeDimensionFun(scope.row.bbId)" style="color:#409EFF;">{{scope.row.staffCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="拉新用户数" align="center">
            <template scope="scope">
              <span style="color:#409EFF;" @click="pullNewFun(0,scope.row.bbId)">{{scope.row.newUserCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="平台会员" align="center">
            <template scope="scope">
              <span style="color:#409EFF;" @click="pullNewFun(1,scope.row.bbId)">{{scope.row.newUserVIPCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易笔数" align="center">
            <template scope="scope">
              <span style="color:#409EFF;" @click="orderDimensionFun(scope.row.bbId)">{{scope.row.newUserOrderCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易金额（元）" align="center">
            <template scope="scope">
              <span style="color:#409EFF;" @click="orderDimensionFun(scope.row.bbId)">{{scope.row.newUserOrderSum}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabSeventh"
        :current-page="pageIndexSeventh" :page-size="10" :total="totalRowsCountSeventh" style="float: right; margin: 10px 0"/>
      </div>
    </div>
    <!-- 员工维度 -->
    <div v-if="statusMA==6">
      <div class="table_container">
        <el-table :data="EDList" @selection-change="handleSelectionChange" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="员工" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="拉新用户数" align="center">
            <template scope="scope">
              <span style="color:#409EFF;" @click="pullNewFun1(0,scope.row.id)">{{scope.row.newUserCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="平台会员" align="center">
            <template scope="scope">
              <span style="color:#409EFF;" @click="pullNewFun1(1,scope.row.id)">{{scope.row.newUserVIPCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易笔数" align="center">
            <template scope="scope">{{scope.row.newUserOrderCount}}</template>
          </el-table-column>
          <el-table-column label="交易金额（元）" align="center">
            <template scope="scope">{{scope.row.newUserOrderSum}}</template>
          </el-table-column>
          <el-table-column label="佣金" align="center">
            <template scope="scope">{{scope.row.commission}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabEighth"
        :current-page="pageIndexEighth" :page-size="10" :total="totalRowsCountEighth" style="margin:10px 0;float:right"/>
      </div>
    </div>
    <!-- 订单维度 -->
    <div v-if="statusMA==7">
      <div class="table_container">
        <el-table :data="ODList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="订单号" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.orderNo">{{scope.row.orderNo}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易时间" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
          <el-table-column label="所属店铺" align="center">
            <template scope="scope">{{scope.row.bbName}}</template>
          </el-table-column>
          <el-table-column label="用户昵称" align="center">
            <template scope="scope">{{scope.row.userName}}</template>
          </el-table-column>
          <el-table-column label="交易金额（元）" align="center">
            <template scope="scope">{{scope.row.price}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template scope="scope">
              <span @click="seeOrderFun(scope.row.id)" class="handle"> <i class="el-icon-view"/> 查看 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabtenth"
        :current-page="pageIndexTenth" :page-size="10" :total="totalRowsCountTenth" style="margin:10px 0;float:right"/>
      </div>
    </div>
    
    <div v-if="statusMA==6||statusMA==7" style="margin:15px 0;text-align: center;">
      <el-button @click="returnSixFun">返回</el-button>
    </div>
  </div>
    
  <!-- 拉新用户数 右侧抽屉组件 -->
  <el-drawer :title="titSix" custom-class="registrationRecord" :visible.sync="newUsersDrawer" direction="rtl" size="48%">
    <el-table :data="pullNewOrVipList" border>
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="name" label="用户昵称" align="center"/>
      <el-table-column property="phone" label="手机电话" align="center"/>
      <el-table-column property="newUserOrderCount" label="交易笔数" align="center"/>
      <el-table-column property="newUserOrderSum" label="交易金额(元)" align="center"/>
    </el-table>
    <!-- 拉新用户数-分页 -->
    <el-pagination layout="prev, pager, next" @current-change="handleTabSix"
    :current-page="pageIndexSix" :page-size="10" :total="totalRowsCountSix" style="float: right; margin-top: 10px"/>
  </el-drawer>
  
  <!-- 查看大图 -->
  <el-dialog :visible.sync="isShowImageDialog" @closed="clearImg" title='查看大图'>
    <div class="imgDialog">
      <img style="width:auto; height:auto; max-width:100%; max-height:100%;" :src="showImageUrl"/>
    </div>
  </el-dialog>

  <!-- 订单详情 -->
  <el-drawer title="订单详情" custom-class="registrationRecord" :visible.sync="orderDetDrawer" direction="rtl" size="48%">
    <div class="drawerDiv" style="position:relative;">
      <ul>
        <!-- StatusId -->
        <li>订　单　号：<span>{{orderDet.orderNo}}</span></li>
        <li>创　建　日　期：<span>{{orderDet.cTime}}</span></li>
        <li>交　易　品　牌：<span><strong>{{orderDet.brandName}}</strong></span></li>
        <li>付　款　门　店：<span>{{orderDet.store}}</span></li>
        <li>商　品　总　价：<span>{{orderDet.totalPrice}}</span></li>
        <li>用户 ：<span>{{orderDet.userName}}</span></li>
        <li>用　户　电　话：<span>{{orderDet.userPhone}}</span></li>
        <li>实　付　金　额：<span>{{orderDet.price}}</span></li>
        <li>返　现　金　额：<span>{{orderDet.returnPrice}}</span></li>
        <li>纸　质　凭　证：
          <img class="imgStyle" v-for="item in orderDet.vouchers" :key="item.orderNo" :src="item" @click="showDialog(item)">
        </li>
        <li>交　易　备　注：<span>{{orderDet.remark}}</span></li>
      </ul>
      <div style="position:absolute;bottom:-60px;left:50%;">
        <el-button type="danger" @click="orderDetDrawer=false" style="margin-top: -10px;">关 闭</el-button>
      </div>
    </div>
  </el-drawer>

  <!-- 创建联盟/编辑联盟 弹框 -->
  <el-dialog :center="true" :title="isEdit?'编辑联盟':'创建联盟'" :visible.sync="createAllianceAdd" width="50%">
    <el-form :model="createAllianceForm" :rules="rules" ref="createAllianceForm">
      <el-form-item label="联盟名称:" label-width="100px" prop="allianceNickname">
        <el-input type="text" v-model="createAllianceForm.allianceNickname"
          placeholder="请输入联盟名称（不超过15个字）" maxlength="15" style="width: 80%"/>
      </el-form-item>
      <!-- 商品图片 -->
      <el-form-item prop="goodsImgUrl" label="联盟LOGO:" label-width="100px" style="width: 100%">
        <div class="uploadActive">
          <el-upload v-show="isdisabled" class="avatar-uploader proportionImg"
            style action :show-file-list="false" :before-upload="beforeAvatarUpload">
            <div v-if="goodsImgUrl" style="position:relative">
              <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="deleteIconFun"/>
              <img :src="goodsImgUrl" style="width: 80px; height: 80px"/>
            </div>
            <div v-if="!goodsImgUrl">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </div>
        <div style="color: #888;"> 建议尺寸：比例为1 : 1　支持的图片格式：jpg、png </div>
      </el-form-item>
      <el-form-item label="联盟联系人:" prop="allianceName" label-width="100px">
        <el-input type="text" v-model="createAllianceForm.allianceName"
        placeholder="请输入联盟姓名" maxlength="10" style="width: 80%"/>
      </el-form-item>
      <el-form-item label="联系电话:" prop="alliancePhone" label-width="100px">
        <el-input type="text" v-model="createAllianceForm.alliancePhone"
        placeholder="请输入联盟电话" maxlength="11" style="width: 80%"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="createAllianceAdd = false">取 消</el-button>
      <el-button type="danger" @click="newMAFun()">确定</el-button>
    </div>
  </el-dialog>

  <!-- 重要提示 -->
  <el-dialog :center="true" title="重要提示" :visible.sync="importantIips" width="30%">
    <el-form class="findform">
      {{tipsText}}
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="importantIips = false">取 消</el-button>
      <el-button type="danger" @click="sureTipsFun()">确定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="添加员工" :visible.sync="addEmployee" width="30%" center>
    <div style="width:100%;text-align: center;margin-bottom: 20px;">
      <b>操作提示：请让员工打开微信进行扫码，即可添加员工。</b>
      <img :src="staffQRCode" style="width: 260px;height: auto;margin: 20px 0 10px 0;"/> <br>
      <el-button type="primary" size="small" @click="xiazaiYg()">下载员工码</el-button>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="importantIips = false">取 消</el-button>
      <el-button type="danger" @click="sureTipsFun()">确定</el-button>
    </div> -->
  </el-dialog>

  <!-- 解散联盟 -->
  <el-dialog :center="true" title="解散联盟" :visible.sync="dissolutionPopup" width="30%" :closeOnClickModal="false">
    <el-form>
      <div style="margin-bottom:20px;">您确定要解散当前联盟吗？此操作不可逆，请谨慎操作！</div>
      <el-form-item label="联系人:" prop="allianceName" style="margin-bottom:0;">
        <div>{{dismissPhone}}</div>
      </el-form-item>
      <el-form-item label="验证码:" prop="code" class="pr">
        <el-input prop="code" v-model="loginForm.code" placeholder="验证码" class="print"></el-input>
        <button @click="getCode()" class="code-btn" :disabled="!show">
          <span v-show="show">发送验证码</span>
          <span v-show="!show" class="count">{{count}} s</span>
        </button>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dissolutionPopup = false">取 消</el-button>
      <el-button type="danger" @click="sureVCordFun()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="mengzhu" @closed="clearMz" width="25%" center>
    <p style="text-align:center;margin-bottom: 30px;">确定要将“{{mzName}}”店设置为盟主店吗？</p>
    <div style="text-align:center">
      <el-button @click="mengzhu = false">取消</el-button>
      <el-button type="danger" @click="defineMz()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 请选择店铺 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="26%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import { uploadOSS } from '../../utils/oss'; // oss上传视频
import { getOssFile, userIdentity, } from '../../api/newOss';
import { shopQRCode,cooperationStaffList,delCooperationStaff, merchantAllianceAdd,merchantAllianceList,settingMain,signOut,
merchantAllianceTree,merchantAllianceNotInMyMA,merchantAllianceInvitation,merchantAllianceMy,cancelInvitation,removeMerchant,
sendInvitationMessage,myMerchantAllianceList,agreeJoinMA,refuseJoinMA,seeMABase,seeMAList,sendDissolution,dissolution, 
getShopHasAlliance,statisticsList,bbJoinMaList,statisticsewUserList,statisticsewStaffList,statisticsStaffNewUserList,
statisticsewOrderList,statisticsewOrder, putReplaceMaster, merchantAllianceEdit,} from "../../api/attractInvestment";
import ActivityManagementList from "../staging/ActivityManagementList";
const TIME_COUNT = 60 // 倒计时的时间
export default {
  name: 'merchantAlliance',
  data() {
    return {
      showImageUrl: "", // 图片地址
      isShowImageDialog: false, // 图片查看
      ODList: [],
      orderDet: '',
      bbidSix: '',
      pullNewRow:'',
      pullNewId:'',
      pullNewRow1:'',
      pullNewId1:'',
      EDList: [],   //员工维度列表
      pullNewOrVipList: [],     //拉新用户数、平台会员列表
      titSix: '',   // 拉新用户数或者平台会员弹框标题
      allianceDataList: [],
      beginDate: '',
      endDate: '',
      maIdSix: '',
      tabPosition: 0,
      newUsersDrawer: false,    //拉新用户数抽屉控制显隐
      newUsersList: [],       //拉新用户数数组
      orderDetDrawer: false,    //订单详情抽屉控制显隐
      
      value2: '',
      addEmployee: false, //点击添加员工按钮，控制添加员工弹框显隐
      basicInformation: [], //查看联盟基本信息
      tipsState:'',   //当前操作的哪个按钮，点击重要提示的确定按钮时用到
      tipsText:'',  //重要提示内容
      statusMA:1,//1=我的联盟列表,2我的联盟列表点击查看，3管理联盟,4邀请商家,5员工维度
      loginForm: {
        mobile: '',
        code: ''
      },
      show: true,
      count: '',
      timer: null,
      importantIips: false,  //控制显示重要提示弹框
      dissolutionPopup: false,
      dialogVisibleadd: false,
      activeName: 'first',
      bbid:'',  //店铺id
      options1: [],
      options2: [],
      filters: {
        EnterpriseName: "", // 企业名称
      },
      // 树形控件
      oneData: [],
      defaultCheckedKeys: [],     //树形控件默认选中数组
      defaultProps: {
        label: 'name',
        children: 'node',
      },
      showImageUrl: '',   //店铺码
      staffQRCode: '',  //员工码
      tableListOne: [], //我的联盟列表
      lmpageIndex: 1,
      lmtotalRowsCount: 0, 

      brandList: [],  //我的联盟选择列表
      twoList: [],    //入盟邀请列表
      threeList: [],    //我的员工列表
      pageIndexTabOne: 1,
      ygtotalRowsCount: 0,

      searchName: '店铺名称',
      tid: '',  //我的联盟店铺合作列表入参记录
      bid: '',  //我的联盟店铺合作列表入参记录
      Brandarr: [],
      brandIndex: [],
      scrollbarHeight: '',
      bbType: '',  //店铺类型  1=品牌店、2=装修公司	
      resData: '',
      pageIndexTwo:1,   //入盟邀请列表
      totalRowsCountTwo: 0, //入盟邀请总数
      pageIndexThree: 1,    //查看联盟已加入店铺列表分页
      totalRowsCountThree: 0, //查看联盟已加入店铺列表总数
      threeMAList: [],    //查看联盟已加入店铺列表
      pageIndexFour: 1,   //管理联盟-我的联盟列表分页
      totalRowsCountFour: 0, //管理联盟-我的联盟列表总数
      fourMAList: [],     //管理联盟，我的联盟数组
      pageIndexFive: 1,   //管理联盟-邀请商家列表分页
      totalRowsCountFive: 0, //管理联盟-邀请商家列表总数
      pageIndexSix: 1,   //联盟数据-拉新用户数列表分页
      totalRowsCountSix: 0, //联盟数据-拉新用户数列表总数
      pageIndexSeventh: 1,   //联盟数据-拉新用户数列表分页
      totalRowsCountSeventh: 0, //联盟数据-拉新用户数列表总数
      pageIndexEighth: 1,   //联盟数据-员工维度列表分页
      totalRowsCountEighth: 0, //联盟数据-员工维度列表总数
      pageIndexNinth: 1,   //联盟数据-拉新用户数列表分页
      totalRowsCountNinth: 0, //联盟数据-拉新用户数列表总数
      pageIndexTenth: 1,   //订单维度列表分页
      totalRowsCountTenth: 0, //订单维度


      groupWorkArr: [],   //被邀联盟选中的数组
      createAllianceAdd: false,   //控制显示创建联盟弹框
      createAllianceForm: {
        allianceNickname:'',
        allianceName: '',
        alliancePhone: '',
        coverImg: '',
      },
      // rules表单验证
      rules: {
        allianceNickname: [
          { required: true, message: '请输入15字以内的联盟名称', trigger: 'blur' }
        ],
        allianceName: [
          { required: true, message: '请输入联盟姓名', trigger: 'blur' }
        ],
        alliancePhone: [
          { required: true, message: '请输入联盟电话', trigger: 'blur' }
        ],
      },
      isdisabled: true,
      goodsImgUrl: "", // 联盟logo
      isCreateMA: '', //1=有自己创建的联盟、0=无自己创建的联盟	
      dismissPhone:'',    //点击解散联盟时用的手机号
      isEdit: false,   //是否是编辑联盟信息
      oneId: '', // 获取联盟第一个id
      oneName: '', // 获取联盟第一个name
      youLmId: 0, // 1=有、0=无
      mengzhu: false, // 确认提示
      mzName: '', // 盟主名称
      mzid: '', // 选中行id
    }
  },
  components: {
    ActivityManagementList, // 联盟活动
  },
  methods: {
    // 设为盟主
    sheweiMz(row) {
      this.mzName = row.name;
      this.mzid = row.bbId;
      this.mengzhu = true;
    },
    // 设为盟主-确定
    defineMz() {
      let addParams = {
        bbid: this.bbid, // 当前店铺id
        maId: this.maId, // 联盟id
        newMasterBbId: this.mzid, // 新盟主店铺id
      };
      putReplaceMaster(addParams).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type:"success",
            // text: '操作成功!'
            text: data.resultMsg
          })
          this.mengzhu = false;
          this.statusMA=1; // 显示联盟列表
          this.createAllianceAdd = false;
          this.MAlist();
        } else {
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      })
    },
    // 设为盟主-取消
    clearMz() {
      this.mengzhu = false;
    },
    // 查看图片
    showDialog(itemImg) {
      this.isShowImageDialog = true;
      this.showImageUrl = itemImg;
    },
    // 关闭查看大图
    clearImg(){
      this.isShowImageDialog = false
    },
    deleteIconFun(){
      this.goodsImgUrl = '';
    },
    // 点击返回按钮
    returnFun(){
      this.statusMA=1;
    },
    // 查看联盟点击返回按钮
    returnSeeFun(){
      this.statusMA=1;
      this.filters.EnterpriseName = '';
    },
    // 查看联盟点击返回按钮
    returnSeeFuna(){
      this.statusMA=3;
      this.filters.EnterpriseName = '';
      this.manageMAList();    //管理联盟列表
    },
    /* 管理联盟 */
    // 管理联盟-邀请商家-左侧树
    
    // 我的联盟tab获取合作品类树
    brandTypeTree(){
      merchantAllianceTree().then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.oneData = data.resultObj;
            this.defaultCheckedKeys.push(data.resultObj[0].id);
            this.tid = data.resultObj[0].id;
            this.bid = [];
            this.cooperationList(data.resultObj[0].id,[]);
          }
        }
      })
    },
    // 解散联盟
    dissolutionMA(){
      this.dissolutionPopup = true;
    },
    // 编辑联盟信息
    editMA(){
      this.isEdit = true;   //是否是编辑联盟信息
      this.createAllianceAdd = true;
      this.createAllianceForm.allianceNickname = this.basicInformation.name;
      this.createAllianceForm.allianceName = this.basicInformation.contacts;
      this.createAllianceForm.alliancePhone = this.basicInformation.contactsPhone;
      this.createAllianceForm.coverImg = this.basicInformation.logoUrl.replace(localStorage.BaseOssUrl,'');
      this.goodsImgUrl = this.basicInformation.logoUrl;
    },
    // 邀请商家
    inviteMerchants(){
      this.statusMA=4;  //邀请商家
      this.brandTypeTree();
    },
    // 管理联盟列表
    manageMAList(){
      let addParams = {
        key: this.filters.EnterpriseName, // 关键字
        maId: this.maId,
        pageIndex: this.pageIndexFour,
        pageSize: 10
      };
      merchantAllianceMy(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            let dataArr = data.resultObj;
            dataArr.resultObj.forEach(item=>{
              item.bbTypeName = item.bbType==1?'品牌建材':'装修公司';
              item.stateName = item.state==1?'已加入':'邀请中';
            })
            this.fourMAList = dataArr.resultObj;
            this.totalRowsCountFour = data.resultObj.rowsCount;
          } else {
            this.fourMAList = [];
          }
        } else {
            this.fourMAList = [];
        }
      })
    },
    // 移除商家/取消联盟邀请/发送联盟邀请通知
    fourMATipsFun(row,state){
      let addParams = {
        bbId: row.bbId,   //店铺id
        maId: this.maId, // 联盟id
      };
      let thisApi = state==1?cancelInvitation:state==2?sendInvitationMessage:removeMerchant;
      thisApi(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.$swal({
              type:"success",
              text: '操作成功!'
            })
            this.manageMAList();
          }
        }
      })
    },
    /*入盟邀请 */
    // 入盟邀请-同意或拒绝
    invitationFun(row,state){
      // state==1同意入盟，2拒绝入盟
      let addParams = {
        bbId: this.bbid, // 联盟id
        maId: row.id,
      };
      let thisApi = state==1?agreeJoinMA:refuseJoinMA;
      thisApi(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.$swal({
              type:"success",
              text: '操作成功!'
            })
            this.invitedShopList();
          }
        }
      })
    },
    //查看联盟已加入店铺列表
    seeMAListFun(row){
      let addParams = {
        key: this.filters.EnterpriseName, // 关键字
        maId: this.maId,
        pageIndex: this.pageIndexThree,
        pageSize: 10
      };
      seeMAList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            let res = data.resultObj;
            res.resultObj.forEach(item=>{
              item.bbTypeName = item.bbType==1?'品牌建材':'装修公司';
            })
            this.threeMAList = res.resultObj;
            this.totalRowsCountThree = res.rowsCount;
          } else {
            this.threeMAList = [];
          }
        } else {
            this.threeMAList = [];
        }
      })
    },
    //查看联盟基本信息
    seeMABaseFun(row){
      let addParams = {
        maId: this.maId,
      };
      seeMABase(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.basicInformation = data.resultObj; // 基本信息
          }
        }
      })
    },
    
    // 点击联盟列表操作按钮
    operationButton(row,state){
      // state=1:取消申请，2设为主推，3退出，4查看，5管理联盟
      this.tipsState = state;   //当前操作的是哪个按钮
      this.maId = row.id;
      if(state==1){   //取消申请
        this.importantIips = true;
        this.tipsText = `您确定要取消创建${row.name}联盟的申请吗？`;
      } else if(state==2){   //设为主推
        this.importantIips = true;
        this.tipsText = `您确定将${row.name}联盟设置为主推联盟吗？`;
      } else if(state==3){   //退出
        this.importantIips = true;
        this.tipsText = `您确定将您的店铺从${row.name}联盟中退出吗？退出后如想再次加入该联盟请联系${row.contactsPhone}再次邀请您加入。`;
      } else if(state==4){      //查看
        this.statusMA= 2;   //查看联盟
        this.pageIndexThree = 1;
        this.seeMAListFun(row);  //查看联盟已加入店铺列表
        this.seeMABaseFun(row);  //查看联盟基本信息
      } else if(state==5){     //管理联盟
        this.statusMA= 3;   //管理联盟
        this.dismissPhone = row.contactsPhone;   //点击解散联盟时用的手机号
        this.manageMAList();    //管理联盟列表
        this.seeMABaseFun(row);  //查看联盟基本信息
      }
    },
    // 点击重要提示-确定按钮
    sureTipsFun(){
      // 1:取消申请，2设为主推，3退出
      if(this.tipsState==1||this.tipsState==2||this.tipsState==3){
        let addParams = {};
        if(this.tipsState==1){
          addParams = {
            userId: Number(localStorage.Id), // 当前登陆人id
            maId: this.maId,
            bbId: this.bbid,
          };
        } else if(this.tipsState==2||this.tipsState==3){
          addParams = {
            maId: this.maId,
            bbId: this.bbid,
          };
        }
        let thisApi = this.tipsState==1?cancelInvitation:this.tipsState==2?settingMain:signOut;
        thisApi(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.$swal({
                type:"success",
                text: '操作成功!'
              })
              this.importantIips = false;
              this.MAlist();
            }
          }
        })
      }
    },
    // 点击新增联盟弹框确定按钮
    newMAFun(){
      this.$refs['createAllianceForm'].validate(valid => {
        if (valid) {
          if(!this.goodsImgUrl){
            this.$swal({
              type:"warning",
              text: '请上传联盟LOGO!'
            })
          } else {
            if(this.isEdit){    //编辑联盟
              let addParams = {
                maId: this.maId,
                name: this.createAllianceForm.allianceNickname,
                logo: this.createAllianceForm.coverImg,
                contacts: this.createAllianceForm.allianceName,
                contactsPhone: this.createAllianceForm.alliancePhone,
              };
              merchantAllianceEdit(addParams).then(data => {
                if (data) {
                  if (data.resultCode == 1) {
                    this.$swal({
                      type:"success",
                      text: '编辑成功!'
                    })
                    this.statusMA=1;   //显示联盟列表
                    this.createAllianceAdd = false;
                    this.MAlist();
                  }
                }
              })
            } else {      //新增联盟
              let addParams = {
                userId: Number(localStorage.Id), // 当前登陆人id
                bbid: this.bbid,
                name: this.createAllianceForm.allianceNickname,
                logo: this.createAllianceForm.coverImg,
                contacts: this.createAllianceForm.allianceName,
                contactsPhone: this.createAllianceForm.alliancePhone,
              };
              merchantAllianceAdd(addParams).then(data => {
                if (data) {
                  if (data.resultCode == 1) {
                    this.$swal({
                      type:"success",
                      text: '申请创建联盟已提交审核，请等待通知'
                    })
                    this.createAllianceAdd = false;
                    this.MAlist();
                  }
                }
              })
            }
          }
        } else {
          return false;
        }
      })
    },
    // 点击获取验证码
    getCode () {
      sendDissolution(this.maId).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            // 验证码倒计时
            if (!this.timer) {
              this.count = TIME_COUNT
              this.show = false
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--
                } else {
                  this.show = true
                  clearInterval(this.timer)
                  this.timer = null
                }
              }, 1000)
            }
          }
        }
      })
    },
    // 点击确定验证码
    sureVCordFun(){
      let addParams = {
        maId: this.maId,
        Code: this.loginForm.code
      };
      dissolution(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dissolutionPopup = false;  //隐掉解散联盟弹框
            this.statusMA=1;
            this.MAlist();
            this.$swal({
              type:"success",
              text: '操作成功!'
            })
          }
        }
      })
    },
    // 点击入盟邀请
    goInvite(){
      this.activeName = 'second';
    },
    //点击申请创建联盟
    createAllianceAddFun(){
      this.isEdit = false;
      this.createAllianceAdd = true;
    },
    // 联盟logo
    beforeAvatarUpload(file) {
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      }).then(() => {
          var that = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function (e) {
            /* oss 直传图片 */
            var obj = {type: 11};
            getOssFile(obj).then(data => {
              if (data.resultCode == 1) {
                let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
                let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
                let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
                let ossfile = data.resultObj.directory; // 保存路径
                let ossbucket = data.resultObj.bucket; // bucket
                localStorage.setItem('keyossId',ossId);
                localStorage.setItem('keyossSecret',ossSecret);
                localStorage.setItem('keyossHost',ossHost);
                localStorage.setItem('keyossfile',ossfile);
                localStorage.setItem('keyossbucket',ossbucket);
                
              }
            })
            var newOssPic = await uploadOSS(file,0);
            that.goodsImgUrl = newOssPic;
            that.createAllianceForm.coverImg = newOssPic.replace(localStorage.BaseOssUrl,'')

          };
          if (that.imgarr.length >= 1) {
            that.isdisabled = false;
          }
          return file;
        },() => {
          this.$swal({
            type: "warning",
            text: "上传的图片必须是宽高比例为1:1",
          });
          return Promise.reject();
      });
      return isSize;
    },

    // 点击tab切换
    handleClick(tab, event) {
      this.filters.EnterpriseName = ''; // 清空搜索框
      this.activeName = tab.name;
      if(!this.bbid) {
        this.$swal({
          type: "warning",
          text: "请重新打开本功能，并选择一家店铺",
        });
        return false;
      }
      if(tab.name=='first'){
        this.statusMA=1;
        this.MAlist();
      } else if(tab.name=='second'){
        this.statusMA=1;
        this.invitedShopList();     //被邀联盟
      } else if(tab.name=='third'){
        this.searchName = '员工昵称手机号';
        this.pageIndexTabOne = 1;
        this.cooperationStaffList();    //我的员工
      } else if(tab.name == 'fifth'){
        this.$refs.refLmhd.getActiveList(1);
      } else if(tab.name == 'sixth'){     //数据统计
        this.statusMA=5;
        this.bbJoinMaList();      //获取店铺联盟下拉框
      }
    },

    // 获取店铺联盟下拉框
    bbJoinMaList(){
      let addParams = {
        bbid: this.bbid,
      };
      bbJoinMaList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.options2 = data.resultObj;
            this.maIdSix = this.options2[0].id;
            this.pageIndexSeventh = 1;
            this.dataStatistics(); // 数据统计接口
          } else {
            this.options2 = []
          }
        } else {
            this.options2 = []
          }
      })
    },
    // 选择时间段（最近3天等）
    radioType(val) {
      this.value2 = '';
    },
    // 选择具体时间段
    changeActiveTime(time) {
      if(time+""=="null"){
        time = ["",""]
      }
      this.beginDate = time[0];
      this.endDate = time[1];
      this.tabPosition = 0; // 选择的时间段val
    },

    // 联盟数据统计列表
    dataStatistics(){
      if(this.maIdSix) {
        let addParams = {
          maId: this.maIdSix,
          dateType: this.tabPosition,
          beginDate: this.beginDate,
          endDate: this.endDate,
          pageIndex: this.pageIndexSeventh,
          pageSize: 10,
        };
        statisticsList(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.allianceDataList = data.resultObj.resultObj;
              this.totalRowsCountSeventh = data.resultObj.rowsCount;
            } else {
              this.allianceDataList = []
            }
          } else {
              this.allianceDataList = []
            }
        })
      } else {
        this.$swal({
          type: "warning",
          text: "请选择联盟",
        });
      }
    },

    // 员工数--跳转员工维度
    employeeDimensionFun(id){
      let addParams = {
        bbid: id,     //点击列表查看的店铺id
        dateType: this.tabPosition,
        beginDate: this.beginDate,
        endDate: this.endDate,
        pageIndex: this.pageIndexEighth,
        pageSize: 10,
      };
      this.bbidSix = id;      //点击员工维度时把当前店铺id存下来，在员工维度里要使用
      statisticsewStaffList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.EDList = data.resultObj.resultObj;
            this.totalRowsCountEighth = data.resultObj.rowsCount;
          } else {
            this.EDList = []
          }
        } else {
          this.EDList = []
        }
      })
      this.statusMA = 6;
      this.pageIndexSix = 1;
    },

    // 交易笔数和交易金额--跳转订单维度
    orderDimensionFun(bbid){
      let addParams = {
        bbid: bbid,     //点击列表查看的店铺id
        dateType: this.tabPosition,
        beginDate: this.beginDate,
        endDate: this.endDate,
        pageIndex: this.pageIndexTenth,
        pageSize: 10,
      };
      this.bbidSix = bbid;
      statisticsewOrderList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.ODList = data.resultObj.resultObj;
            this.totalRowsCountTenth = data.resultObj.rowsCount;
          } else {
            this.ODList = []
          }
        } else {
          this.ODList = []
        }
      })
      this.statusMA = 7;
    },


    // 联盟统计列表-拉新用户数
    pullNewFun(row, id){
      if(row==0){
        this.titSix = '拉新用户数';
      } else {
        this.titSix = '平台会员';
      }
      this.pullNewRow = row;    //暂存用于分页时使用
      this.pullNewId = id;
      let addParams = {
        thisBbid: this.bbid,   //进入模块时下拉框选择的店铺id
        bbid: id,     //点击列表查看的店铺id
        isVip: row,   // 0=拉新用户数、1=平台会员
        dateType: this.tabPosition,
        beginDate: this.beginDate,
        endDate: this.endDate,
        pageIndex: this.pageIndexSix,
        pageSize: 10,
        maId: this.maIdSix, // 联盟id int类型   （列表左上方下拉列表选中的联盟id）
      };

      statisticsewUserList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.pullNewOrVipList = data.resultObj.resultObj;
            this.totalRowsCountSix = data.resultObj.rowsCount;
          } else {
            this.pullNewOrVipList = []
          }
        } else {
          this.pullNewOrVipList = []
        }
      })
      this.newUsersDrawer = true;
    },
    
    // 员工维度列表-拉新用户数
    pullNewFun1(row, id){
      if(row==0){
        this.titSix = '拉新用户数';
      } else {
        this.titSix = '平台会员';
      }
      this.pullNewRow1 = row;    //暂存用于分页时使用
      this.pullNewId1 = id;
      let addParams = {
        thisBbid: this.bbid,   //进入模块时下拉框选择的店铺id
        bbid: this.bbidSix,     //点击列表查看的店铺id
        staffId: id,    //员工id
        isVip: row,   // 0=拉新用户数、1=平台会员
        dateType: this.tabPosition,
        beginDate: this.beginDate,
        endDate: this.endDate,
        pageIndex: this.pageIndexSix,
        pageSize: 10,
        maId: this.maIdSix, // 联盟id int类型   （列表左上方下拉列表选中的联盟id）
      };

      statisticsStaffNewUserList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.pullNewOrVipList = data.resultObj.resultObj;
            this.totalRowsCountSix = data.resultObj.rowsCount;
          } else {
            this.pullNewOrVipList = []
          }
        } else {
          this.pullNewOrVipList = []
        }
      })
      this.newUsersDrawer = true;
    },

    // 点击员工维度和订单维度的返回按钮
    returnSixFun(){
      this.statusMA = 5;
    },

    // 点击数据统计返回
    cancelForm(){
      this.statusMA = 7;
    },
    
    // 联盟统计查询按钮
    onSubmitSixFun(){
      this.pageIndexSeventh = 1;
      this.dataStatistics();      //数据统计接口
    },

    // 点击订单维度-查看
    seeOrderFun(id){
      let addParams = {
        thisBbid: this.bbid,   //进入模块时下拉框选择的店铺id
        orderId: id,    //员工id
      };

      statisticsewOrder(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.orderDet = data.resultObj;
          } else {
            this.orderDet = []
          }
        } else {
          this.orderDet = []
        }
      })
      this.orderDetDrawer = true;
    },

    // 我的联盟列表
    MAlist(){
      let addParams = {
        bbid: this.bbid,
        key: this.filters.EnterpriseName,
        pageIndex: this.lmpageIndex,
        pageSize: 10,
      };
      merchantAllianceList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            data.resultObj.resultObj.forEach(item=>{
              item.stateName = item.state==1?'待审核':item.state==2?'已通过':item.state==3?'已通过':'已取消';
              item.isMainMAName = item.isMainMA==1?'是':'否';
              item.identityName = item.identity==1?'盟主':'成员';
            })
            this.tableListOne = data.resultObj.resultObj;
            this.lmtotalRowsCount = data.resultObj.rowsCount;
            this.isCreateMA = data.resultMsg||0;   //1=有自己创建的联盟、0=无自己创建的联盟
            this.oneId = this.tableListOne[0].id; // 第一个id
            this.oneName = this.tableListOne[0].name; // 第一个name
          } else {
            this.tableListOne = [];
            this.isCreateMA = 0;   //1=有自己创建的联盟、0=无自己创建的联盟
            this.oneId = '';
          }
        } else {
          this.tableListOne = [];
          this.isCreateMA = 0;   //1=有自己创建的联盟、0=无自己创建的联盟
          this.oneId = '';
        }
      })
    },

    // 入盟邀请
    invitedShopList(){
      let addParams = {
        bbid: this.bbid,
        pageIndex: this.pageIndexTwo,
        pageSize: 10,
      };
      myMerchantAllianceList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            data.resultObj.resultObj.forEach(item=>{
              item.stateName = item.state==1?'邀请中':item.state==2?'已同意':'已拒绝'
            })
            this.twoList = data.resultObj;
            this.totalRowsCountTwo = data.resultObj.rowsCount;
          } else {
            this.twoList = [];
          }
        } else {
            this.twoList = [];
        }
      })
    },
    // 选择品类树列表
    handleNodeClick(data,d1,d2) {
      this.filters.EnterpriseName = '';     //清空搜索框
      if(data.id==-1||data.id==-2){
        this.tid = data.id;
        this.bid = 0;
        this.cooperationList(data.id,0);
      } else {
        // this.filters.EnterpriseName = '';     //清空搜索框
        if(d1.level==2){
          this.tid = data.id;
          this.bid = '';
        } else if (d1.level==3){
          this.bid = data.id;
          
          if(this.tid!=''&&this.bid!=''){
            this.cooperationList(this.tid,this.bid);
            this.Brandarr = [];
          }
        }
      }
    },

    // 管理联盟-邀请商家-获取未邀请的店铺列表
    cooperationList(tid,bid){
      let addParams = {
        maId: this.maId,
        typeid: tid, //（品类树一级id）类型 -1=全部 -2=装修公司   其他为品类id
        brandid: bid,  //（品类树三级id）品牌id
        key: this.filters.EnterpriseName,
        pageIndex: this.pageIndexFive,
        pageSize: 10,
      };
      merchantAllianceNotInMyMA(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.resData = data.resultObj;
            this.bbType = data.resultObj.bbType;
            this.brandList = data.resultObj.resultObj;
            this.Brandarr = [];
            this.brandList.forEach(element => {
              if(element.isSelect == 1){
                this.Brandarr.push(element.id)
              }
            });
            this.totalRowsCountFive = data.resultObj.rowsCount;
          }
        }
      })
    },

    // 点击品牌品类
    choosedBrand(item, index) {
      if (this.Brandarr.indexOf(item.id) > -1) {
        this.Brandarr.splice(this.Brandarr.indexOf(item.id), 1);
        this.$set(item, "isSelect", 0);
      } else {
        this.Brandarr.push(item.id);
        this.$set(item, "isSelect", 1);
      }
    },

    // 点击全选
    choosedAllBrand(item){
      this.Brandarr = [];
      this.brandIndex = [];
      this.brandList.forEach(element => {
        element.isSelect = 1;
        this.Brandarr.push(element.id)
      });
    },

    // 点击确定邀请按钮
    saveFun(){
      if(this.groupWorkArr.length>0){
        let addParams = {
          userId: Number(localStorage.Id), // 当前登陆人id
          maId: this.maId,
          bbIds: this.groupWorkArr
        };
        merchantAllianceInvitation(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.$swal({
                type: "success",
                text: "邀请成功！",
              });
              this.cooperationList(this.tid,this.bid)
            }
          }
        })
      } else {
        this.$swal({
          type: "warning",
          text: "请先勾选列表",
        });
      }
    },
    
    // 被邀联盟复选框
    handleSelectionChange(val) {
      this.groupWorkArr = [];
      val.forEach(element => {
        this.groupWorkArr.push(element.id);
      });
    },

    // 我的员工列表
    cooperationStaffList(){
      let addParams = {
        bbid: this.bbid,
        key: this.filters.EnterpriseName,
        pageIndex: this.pageIndexTabOne,
        pageSize: 10,
      };
      cooperationStaffList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.threeList = data.resultObj.resultObj;
            this.ygtotalRowsCount = data.resultObj.rowsCount;
          } else {
            this.threeList = []
          }
        } else {
            this.threeList = []
          }
      })
    },

    // 删除员工
    deleteFun(row){
      let addParams = {
        bbid: this.bbid,
        staffUserId: row.id
      };
      delCooperationStaff(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功！",
            });
            this.cooperationStaffList();
          } else {
            this.$swal({
              text: data.resultMsg,
              type: "warning"
            })
          }
        }
      })
    },

    /**
     * 根据图片路径下载图片
     * @param imgsrc 图片地址
     * @param name 保存的图片名
     */
    downloadImage(imgSrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题,
      image.setAttribute("crossorigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 将图片格式转为base64
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "myPhoto"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgSrc + '?time=' + Date.now();  // 注意，这里是灵魂，否则依旧会产生跨域问题
    },
    // 下载店铺码
    xiazai() {
      let address = this.showImageUrl;
      let intercept = this.showImageUrl.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },
    // 下载员工二维码
    xiazaiYg() {
      let address = this.staffQRCode;
      let intercept = this.staffQRCode.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },

    // 获取店铺码
    shopQRCode(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
        bbid: this.bbid
      };
      shopQRCode(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.showImageUrl = data.resultObj.qrCode;        //店铺
            this.staffQRCode = data.resultObj.staffQRCode;    //员工
          }
        }
      })
    },


    //查询
    onSubmit() {
      if(this.activeName=='first'){
        // this.cooperationList(this.tid,this.bid);
        if(this.statusMA==1){     //我的联盟主列表
          this.lmpageIndex = 1;
          this.MAlist();
        } else if(this.statusMA==2){  //我的联盟--查看联盟
          this.pageIndexThree = 1;
          this.seeMAListFun();
        } else if(this.statusMA==3){  //我的联盟--管理联盟--列表
          this.pageIndexFour = 1;
          this.manageMAList();
        } else if(this.statusMA==4){  //我的联盟--管理联盟--邀请商家
          this.pageIndexFive = 1;
          this.cooperationList(this.tid,this.bid)
        }
      }
      if(this.activeName=='second'){
        if(this.statusMA==1){     //我的联盟主列表
          this.pageIndexTwo = 1;
          this.invitedShopList();     //被邀联盟
        } else if(this.statusMA==2){  //我的联盟--查看联盟
          this.pageIndexThree = 1;
          this.seeMAListFun();
        }
      }
      if(this.activeName=='third'){
        this.pageIndexTabOne = 1;
        this.cooperationStaffList(); // 我的员工
      }

      this.pageIndex = 1;
      // this.getInit();
    },
    // 我的联盟 分页
    handleTablm(val) {
      this.lmpageIndex = val;
      this.MAlist();
    },
    // 入盟邀请分页
    handleCurrentChange(val) {
      this.pageIndexTwo = val;
      this.invitedShopList();
    },
    // 查看联盟已加入的店铺列表 分页
    handleTabThree(val) {
      this.pageIndexThree = val;
      this.seeMAListFun();
    },
    // 我的员工 分页
    handleTabOne(val) {
      this.pageIndexTabOne = val;
      this.cooperationStaffList();
    },
    // 我的联盟-管理联盟列表 分页
    handleTabFour(val) {
      this.pageIndexFour = val;
      this.manageMAList();
    },
    // 我的联盟-管理联盟-邀请商家列表 分页
    handleTabFive(val) {
      this.pageIndexFive = val;
      this.cooperationList(this.tid,this.bid)
    },
    // 联盟数据-拉新用户数 分页
    handleTabSix(val) {
      if(this.statusMA==6){
        this.pageIndexSix = val;
        this.pullNewFun1(this.pullNewRow1, this.pullNewId1);
      } else {
        this.pageIndexSix = val;
        this.pullNewFun(this.pullNewRow, this.pullNewId)
      }
    },
    // 联盟数据 分页
    handleTabSeventh(val) {
      this.pageIndexSeventh = val;
      this.dataStatistics();
      
    },
    // 员工维度分页
    handleTabEighth(val) {
      this.pageIndexEighth = val;
      this.employeeDimensionFun(this.bbidSix);
    },
    // 订单维度
    handleTabtenth(val) {
      this.pageIndexTenth = val;
      this.orderDimensionFun(this.bbidSix);
    },

    getRowKey (row) {
      return row.id
    },

    //商家联盟获取用户身份以及可查看的店铺
    initshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultMsg==4||data.resultMsg==5){
              this.isShowSave = true;
            } else {
              this.isShowSave = false;
            }
            if(data.resultObj.length>1){
              this.bbid = data.resultObj[0].id;     //店铺id
              this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else {      //默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id;     //店铺id
              this.gonext();
            }
          }else{
            this.$swal({
              type:"warning",
              text:"请先在店铺信息功能中创建自己店铺。"
            })
            return false;
          }
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.$swal({
          type:"warning",
          text:"请选择店铺名称"
        })
        return false
      }
      this.MAlist();    //我的联盟列表
      this.dpsfyytgdlm();
      this.dialogVisibleadd = false;
      this.shopQRCode();    //店铺推广码
    },
    // 店铺是否有已通过的联盟
    dpsfyytgdlm() {
      let addParams = {
        bbId: this.bbid, // 店铺id
      };
      getShopHasAlliance(addParams).then(data=>{
        if (data) {
          if(data.resultCode == 1){
            this.youLmId = data.resultObj; // 1=有、0=无
          }
        }else{
          this.youLmId = 0;
        }
      })
    },
  },
  created() {
    this.initshop(); //商家联盟获取用户身份以及可查看的店铺
    // this.brandTypeTree(); //我的联盟tab获取合作品类树
    // this.shopQRCode();    //店铺推广码
  },
  mounted() {
    this.scrollbarHeight = document.documentElement.clientHeight * 0.7 + "px"
    window.onresize = () => {
      if (this.scrollbarHeight) this.scrollbarHeight = document.documentElement.clientHeight * 0.7 + "px"
    };
  },
  watch: {
    'defaultCheckedKeys':function(newVal, oldVal) {
      if(newVal){
        this.$nextTick(() => {
          document.querySelector('.el-tree-node__content').click()
        })
      }
    },
    dissolutionPopup(value) {
      if (value == false) {
        this.loginForm.code = '';
      }
    },
  },
  

}
</script>
<style scoped>
.spanflex {
  display: flex;
  justify-content: space-around;
}

/* 按钮位置 */
.button_wrap{
  margin: 0 20px 10px;
  display: flex;
  justify-content: flex-end;
}

/* 温馨提示 */
.reminder{
  margin: 0 20px 10px;
  font-size: 14px;
}

/* 我的联盟样式 */
.displayFlex{
  display: flex;
  justify-content: flex-start;
}
.card1{
  width: 30%;
  overflow-y: auto;
}
.card2{
  width: 70%;
  overflow-y: auto;
  position: relative;
}
.button_wrap2{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 40px;
  background: #fff;
  margin: 10px auto;
  margin-left: calc(50% - 33px);
}

/* 店铺码 */
.QRCodeClass {
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
.btn_operation{
  color: #F56C6C;
  cursor: pointer;
}
.faceUrl{
  width: 40px; 
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

/* 验证码样式 */
.pr {
   position: relative;
}
.print{
  width: calc(100% - 84px);
}
.code-btn {
   width: 100px;
   height: 36px;
   position: absolute;
   top: 3px;
   right: 5px;
   z-index: 222;
   color: #F5A623;
   font-size: 14px;
   border: none;
   border-left: 1px solid #e5e5e5;
   padding-left: 16px;
   background-color: #fff;
}

.red{
  color: #f00!important;
}
.return{
  position: absolute;
  bottom: 10px;
  /* left: calc(50% - 40px); */
  left: 20px;
}

.handle{
  padding: 0 5px;
}
.imgStyle{
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: flex;
  justify-content: flex-start;
}

.handle {
  color: #6786b4 !important;
  cursor: pointer;
}
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgDialog>img {
  width:auto; 
  height:auto; 
  max-width:100%; 
  max-height:100%;
  border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// merchantAlliance.vue?4d5f62a4